import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import ShellSaac from '../../../components/shell/ShellSaac';
import { Botao, Icone, PageHeader } from '../../../ui';

import { iniciarNovaAdesao } from '../../../utils/adesaoFluxo';
import { HOME } from '../../home/routes';

/**
 * `/concluido` — fim dos TRÊS fluxos (reescrita na at-60, frente C/C3).
 *
 * ⚠️ **Não tem "Voltar", e é de propósito.** É a única tela terminal do fluxo: a
 * tela anterior é a assinatura de um contrato já assinado, e voltar a ela cairia
 * justamente no estado que esta branch consertou lá ("nada para assinar" — o
 * `location.state` não sobrevive). A saída daqui é para frente: "Início", ou o
 * menu global do shell.
 *
 * ⚠️ **Também não tem `Stepper`:** as seis etapas terminaram na assinatura, e
 * marcar uma sétima inventaria uma etapa que não existe.
 *
 * 🔴 O `iniciarNovaAdesao` no `mount` é o que impede o resíduo da adesão
 * encerrada de vazar para a seguinte (at-38) — inclusive o `rascunhoId`, que já
 * foi concluído e responderia **409** no próximo passo. Não remover.
 */
const Concluido: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    iniciarNovaAdesao(dispatch);
  }, [dispatch]);

  return (
    <ShellSaac cabecalho={<PageHeader titulo="Cadastro concluído" />}>
      <div className="tw-min-h-full tw-bg-shell">
        <div className="tw-mx-auto tw-w-full tw-max-w-3xl md:tw-p-6">
          <div className="tw-bg-white tw-p-6 md:tw-rounded-2xl md:tw-border md:tw-border-superficie-borda md:tw-shadow-[0_2px_12px_rgba(0,0,0,0.09)]">
            <div className="tw-flex tw-flex-col tw-items-center tw-gap-3 tw-py-6 tw-text-center">
              <span className="tw-flex tw-h-14 tw-w-14 tw-items-center tw-justify-center tw-rounded-full tw-bg-success-bg tw-text-success">
                <Icone nome="check" tamanho={28} traco={2.5} />
              </span>

              <h2 className="tw-m-0 tw-font-marca tw-text-xl tw-font-bold tw-text-texto-titulo">
                Cadastro concluído
              </h2>
              <p className="tw-m-0 tw-max-w-md tw-text-sm tw-text-texto-corpo">
                O cadastro do associado no SAAC foi concluído com sucesso.
              </p>

              <Botao
                variante="primario"
                iconeEsquerda="inicio"
                className="tw-mt-3"
                onClick={() => navigate(HOME())}
              >
                Início
              </Botao>
            </div>
          </div>
        </div>
      </div>
    </ShellSaac>
  );
};

export default Concluido;
